import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import InputGradientPicker, {
  PICKER_POSITION,
} from 'hb-react/shared/components/InputGradientPicker';

export { PICKER_POSITION };

const GradientPicker = ({
  defaultGradient,
  disabled = false,
  displayPreview,
  id,
  label,
  name,
  onChange,
  pickerPosition,
  title,
  wrapperProps = {},
}) => {
  const { setFieldValue } = useFormikContext();
  const htmlId = id || name;

  const handleChange = useCallback(
    (value) => {
      setFieldValue(htmlId, value);
      if (onChange) {
        onChange(value);
      }
    },
    [htmlId, onChange, setFieldValue],
  );

  return (
    <Box {...wrapperProps}>
      <Field
        name={name}
        data-testid="formik-gradient-picker"
        disabled={disabled}
      >
        {({ field }) => (
          <InputGradientPicker
            {...field}
            defaultGradient={defaultGradient}
            disabled={disabled}
            displayPreview={displayPreview}
            gradient={field.value}
            id={htmlId}
            label={label}
            name={name}
            onChange={handleChange}
            pickerPosition={pickerPosition}
            resetText={__('Reset gradient')}
            title={title}
          />
        )}
      </Field>
    </Box>
  );
};

GradientPicker.propTypes = {
  name: PropTypes.string.isRequired,
  defaultGradient: PropTypes.shape({
    angle: PropTypes.number,
    color1: PropTypes.string,
    color1Percentage: PropTypes.number,
    color2: PropTypes.string,
    color2Percentage: PropTypes.number,
    inlineCSS: PropTypes.string,
    type: PropTypes.oneOf(['linear', 'radial']),
  }).isRequired,
  disabled: PropTypes.bool,
  displayPreview: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  pickerPosition: PropTypes.oneOf(Object.keys(PICKER_POSITION)),
  title: PropTypes.string,
  wrapperProps: PropTypes.object,
};

export default GradientPicker;
